import React from 'react'
import PicklistField from 'core/components/validatedForm/DropdownField'
import { CalicoDetectionTypes } from './CalicoNetworkFields'
import { NetworkStackTypes } from '../constants'
import AsyncDropdown from 'core/elements/dropdown/AsyncDropdown'

export enum NetworkBackendTypes {
  Flannel = 'flannel',
  Calico = 'calico',
}

const networkBackendOptions = [
  { label: 'Flannel', value: NetworkBackendTypes.Flannel },
  { label: 'Calico', value: NetworkBackendTypes.Calico },
  // { label: 'Canal (experimental)', value: 'canal' },
]

export const handleNetworkBackendChange = (option, stack, wizardContext) => {
  return {
    networkPlugin: option,
    privileged: option === 'calico' ? true : wizardContext.privileged,
    calicoIpIpMode: option === 'calico' ? 'Always' : undefined,
    calicoNatOutgoing: option === 'calico' ? true : undefined,
    calicoBlockSize:
      option === 'calico' && stack === NetworkStackTypes.IPv6
        ? '122'
        : option === 'calico'
        ? '26'
        : undefined,
    calicoDetectionMethod: option === 'calico' ? CalicoDetectionTypes.FirstFound : undefined,
  }
}

const NetworkBackendField = ({
  options = networkBackendOptions,
  wizardContext,
  setWizardContext,
}) => (
  <PicklistField
    DropdownComponent={AsyncDropdown}
    id="networkPlugin"
    label="Network Backend"
    onChange={(value) =>
      setWizardContext(handleNetworkBackendChange(value, wizardContext.networkStack, wizardContext))
    }
    items={options}
    value={wizardContext.networkPlugin}
    tooltip={
      wizardContext.networkStack === NetworkStackTypes.IPv6
        ? 'IPV6 only supports Calico CNI'
        : wizardContext.deployKubevirt
        ? 'Calico CNI is a pre-requisite for KubeVirt'
        : ''
    }
    disabled={wizardContext.deployKubevirt || wizardContext.networkStack !== NetworkStackTypes.IPv4}
    required
  />
)

export default NetworkBackendField
